import { MantineThemeOverride } from '@mantine/core';

export type DividerTheme = NonNullable<MantineThemeOverride['components']>['Divider'];

export const Divider: DividerTheme = {
  // todo: define
};
